export default __webpack_public_path__ + "static/media/skill1.fc7ad997.svg";